module.exports = __webpack_public_path__ + "img/194.1ae72e4b.jpg";